<template>
    <AppLayout
        page="/dashboard"
        pageTitle="First Visits"
        backLink="/dashboard/reports"
    >
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        :subtitle="
                            allLocations
                                ? 'First Visits By Location'
                                : `${selectedLocation.name} First Visits`
                        "
                        :allLocations="allLocations"
                        locationOptions
                        :selectedLocation="selectedLocation"
                        filter
                        :dateRange="dateRange"
                        reportUrl="/dashboard/reports/first-visits"
                        @search="search = $event"
                        dateOptions="upcoming, today, month, year, quarter"
                    />
                    <v-data-table
                        ref="table"
                        :headers="headers"
                        :items="firstVisits"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        :groupBy="allLocations ? 'location' : null"
                        @current-items="collapse()"
                    >
                        <template
                            v-slot:[`group.header`]="{
                                group,
                                items,
                                isOpen,
                                toggle,
                            }"
                        >
                            <th :colspan="headers.length">
                                <v-row
                                    no-gutters
                                    class="flex justify-start align-center pa-2"
                                >
                                    <v-icon @click="toggle" class="mr-3"
                                        >{{ isOpen ? "remove" : "add" }}
                                    </v-icon>
                                    <v-col>
                                        <div
                                            class="soli-grey text-subtitle-1 font-weight-bold"
                                        >
                                            {{ group }}
                                        </div>
                                        <div class="soli-grey text-small">
                                            • {{ items.length }} First Visits
                                        </div>
                                        <div class="soli-grey text-small">
                                            •
                                            {{
                                                `${
                                                    meta.find(
                                                        (e) =>
                                                            e.location == group
                                                    )?.conversion
                                                } Conversion`
                                            }}
                                        </div></v-col
                                    >
                                </v-row>
                            </th>
                        </template>
                        <template v-slot:[`item.student.name`]="{ item }">
                            <div class="d-flex align-center py-2 soli-grey">
                                <v-list-item-avatar
                                    style="float: left"
                                    class="my-0"
                                >
                                    <v-img
                                        :src="item.student.profile_photo_url"
                                    ></v-img>
                                </v-list-item-avatar>
                                <div>
                                    <v-list-item-title>
                                        <Link
                                            :href="`/profile/${item.student.id}/account`"
                                        >
                                            {{ item.student.name }}
                                        </Link>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.student.email }}
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>

                        <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                                small
                                :color="
                                    item.status == 'Lost'
                                        ? 'soli-status-red'
                                        : item.status == 'Enrolled'
                                        ? 'soli-status-green'
                                        : 'accent'
                                "
                                class="white--text font-bold"
                                >{{ item.status }}</v-chip
                            >
                        </template>

                        <template v-slot:[`item.starts_at`]="{ item }">
                            <div class="font-bold soli-grey">
                                {{
                                    item.starts_at
                                        ? globalMomentDate(item.starts_at)
                                        : "No scheduled lessons"
                                }}
                            </div>
                        </template>

                        <template v-slot:[`item.teacher.name`]="{ item }">
                            <Link :href="`/profile/${item.teacher.id}/manage`">
                                {{ item.teacher.name }}
                            </Link>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../../Mixins/GlobalMoment";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import DateRange from "../../Components/Reports/DateRange.vue";
import Stats from "../../Components/Reports/Stats.vue";

export default {
    mixins: [globalMoment],
    props: {
        firstVisits: {
            type: Array,
            default: () => [],
        },
        meta: {
            type: Array,
            default: () => [],
        },
        selectedLocation: {
            type: Object,
            default: () => {},
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
        totalConversion: {
            type: String,
            default: null,
        },
        totalSelfBooked: {
            type: String,
            default: null,
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        DateRange,
        Stats,
    },
    data() {
        return {
            search: "",
            showMessage: false,
            headers: [
                {
                    text: "Student",
                    align: "start",
                    sortable: true,
                    value: "student.name",
                },
                {
                    text: "Status",
                    align: "start",
                    sortable: true,
                    value: "status",
                },
                {
                    text: "Instrument",
                    align: "start",
                    sortable: true,
                    value: "instrument",
                },
                {
                    text: "Class",
                    align: "start",
                    sortable: true,
                    value: "class",
                },
                {
                    text: "Teacher",
                    align: "start",
                    sortable: true,
                    value: "teacher.name",
                },
                {
                    text: "Date",
                    align: "start",
                    sortable: true,
                    value: "starts_at",
                },
            ],
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "First Visits",
                    data: this.firstVisits.length,
                    color: "accent",
                    icon: "school",
                },
                {
                    title: "Conversion",
                    data: this.totalConversion,
                    color: "soli-status-green",
                    icon: "show_chart",
                },
                ,
                {
                    title: "Self-Booked",
                    data: this.totalSelfBooked,
                    color: "secondary",
                    icon: "self_improvement",
                },
            ];
        },
    },
    methods: {
        collapse() {
            if (!this.allLocations) return;
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => (obj[e] = false));
            });
        },
    },
};
</script>
